import { Box, Typography } from "@mui/material";
import ConstructionIcon from "@mui/icons-material/Construction";
import { motion } from "motion/react";

const EnConstruccion = () => {
    return (
        <Box
            sx={{
                minHeight: 400,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                px: 3,
            }}
        >
            <motion.div
                animate={{
                    rotate: [-5, 5, -5],
                }}
                transition={{
                    duration: 2,
                    repeat: Infinity,
                }}
            >
                <ConstructionIcon
                    sx={{
                        fontSize: {
                            xs: 80,
                            md: 120,
                        },
                        color: "#ffd700",
                    }}
                />
            </motion.div>

            <Typography
                sx={{
                    mt: 3,
                    color: "#347571",
                    fontSize: {
                        xs: "2rem",
                        md: "3rem",
                    },
                    fontWeight: 300,
                }}
            >
                Simulador en construcción
            </Typography>

            <Typography
                sx={{
                    mt: 2,
                    maxWidth: 600,
                    color: "#4e6b4d",
                    fontSize: {
                        xs: "1rem",
                        md: "1.2rem",
                    },
                    lineHeight: 1.8,
                }}
            >
                Estamos trabajando para ofrecerte una mejor experiencia.
                Muy pronto podrás calcular tus ahorros, inversiones y
                préstamos de forma rápida y sencilla.
            </Typography>
        </Box>
    );
};

export default EnConstruccion;